import { Flex } from 'onefaceui-react-components';
import styled, { css, keyframes } from 'styled-components';

const zoomInAnimation = keyframes`
   from {
    opacity: 0;
    transform: scale(0);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const startAnimation = keyframes`
 0% { transform: translateX(-100%) }
 100% { transform: translateX(0%)  }
`;

export const Container = styled(Flex)`
  display: none !important;
  position: absolute;
  z-index: 99999;
  width: 380px;
  left: 284px;
  height: 100%;
  background: #fff;
  box-shadow: 4px 5px 6px #00000029;
  border-radius: 4px;
  animation-name: ${startAnimation};
  animation-duration: 0.5s;
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

  .header {
    height: 45px;
    background: var(--grey-200);
    padding: 0 12px;

    .oneface-icon-button {
      img {
        width: 12px;
        height: 12px;
      }
    }
  }

  .tag-color {
    height: 22px;
    width: 8px;
    background: #FF7D00;
  }

  .react-tabs-wrapper {
    height: calc(100% - 45px);

    .react-tabs {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .react-tabs__tab-panel--selected {
      overflow: auto;
      min-height: 0;
      flex: 1;
    }
  }

  ${(props) => props.isOpen
    && css`
      display: flex !important;
    `}

  .tabBadge {
    min-width: 16px;
    min-height: 16px;
    background: var(--red-400);
    border-radius: 50%;
    padding: 2px;
    animation: ${zoomInAnimation} 0.2s ease-out forwards;

    p {
      line-height: 0;
      margin: 0;
    }
  }
`;
